<template>  
    <form>
		<loader v-if="pageLoader"></loader>
		 <p class="alert text-left" :class="(msg_type == 'error')? 'alert-danger' : 'alert-success'" v-if="response_msg != ''">{{response_msg}}<a class="closeTxt" href="javascript:void(0)" @click="response_msg = '' ; msg_type = ''"><x-icon size="1.5x" class="custom-class"></x-icon></a></p>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group">  
              <input type="text" class="form-control" placeholder="Name" name="namee" v-model="namee" v-validate="'required'" />
				<div  v-show="submitted && errors.has('namee')" class="message"> The name is required</div>
          </div>
       </div>
       <div class="col-12 col-md-6">
          <div class="form-group">
              <input type="text" class="form-control" placeholder="Your Email" name="email" v-model="email" v-validate="'required|email'" />
              
			  <div  v-show="submitted && errors.has('email')" class="message"> The Email is required</div>
          </div>
        </div>
       <div class="col-12"> 
           <div class="form-group">
              <textarea class="form-control textarea" id="textarea1" placeholder="Your message" name="message" v-model="msg" v-validate="'required|min:6'"></textarea>
            
			  <div  v-show="submitted && errors.has('message')" class="message"> {{ errors.first('message') }}</div>
         </div>
       </div>
       <div class="col-12 form-group">
          <div class="g-recaptcha">
              <vue-recaptcha sitekey="6Lepj7cjAAAAAPSn-4klVN00HGDMVNmcxzF0nUkB" :loadRecaptchaScript="true" name="captcha" v-model="captcha" v-validate="'required'" @verify="onCaptchaVerified"></vue-recaptcha>
          </div>
		  <div  v-show="submitted && errors.has('captcha')" style="color:#d8583e ; font-size: 12px;"> The Captcha is required</div>
       </div>
       <div class="col-12"> 
        <button v-on:click.prevent="contact_us()" class="uppercase fin_btn w-100" :disabled="disabledVar">Submit</button>
       </div>
      </div> 
    </form>        
</template> 
<script src="https://unpkg.com/vue-recaptcha@latest/dist/vue-recaptcha.js"></script>
<script src="https://unpkg.com/vue@latest/dist/vue.js" defer></script>
<script>

  import VueRecaptcha from 'vue-recaptcha';

  import * as types from '@/types'
  import { mapActions } from 'vuex' 
  import loader from '../loader.vue'
  export default {
      name: 'app',
      data() {
          return {
              msg : '',
			  email : '',
			  namee : '',
              pageLoader : false,
			  submitted : false,
			  msg_type : '',
			response_msg : '',
			captcha : '',
			disabledVar : false
          }
      },
	  props:['page'],
      components: { 
          VueRecaptcha , loader : loader
      },
      methods: {   
			onCaptchaVerified(){
				this.captcha = 'filled'
			},
           cleanVar(){ 
				this.email = ''
				this.namee = ''
				this.msg = ''
				this.captcha = ''
				this.submitted = false
			},
          ...mapActions({
              _runContactUs: types.RUN_CONTACT_US
          }),
          contact_us(){ 
				const _that = this
                _that.submitted = true;
				_that.msg_type = ''
				_that.response_msg = ''
				this.$validator.validate().then(valid => {
					if (valid) {
						let text_data = "email : "+ _that.email +", subject : ''" +", name : "+ _that.namee +", msg : "+ _that.msg
						let input_json={
							'globalParams' :{
								"text": text_data,
								"subject": '',
								"email": _that.email,
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runContactUs(input_json)
					}
				});
          },
          customValidation(getData){                    
              if(getData != ''){  
                  const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  if(!(getData.trim().match(email))){
                      this.errorEmail = 'Please Enter Valid Email'
                  }else{this.errorEmail = ''}
              }
          }, 
          injectScript(params){
              let script_injector = document.createElement('script');
              script_injector.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
              script_injector.async = false;
              script_injector.defer = false;
              document.head.appendChild(script_injector)
          }
      }, 
      created(){ 
       
      },
      mounted() { 
          window.scroll(0,0);
         //window.scroll(0,0)
          if(this.$route.params.page && this.$route.params.page == 'call'){
              document.getElementById("overview").scrollIntoView();
          }else{
              this.$refs.toolbarChat.scrollTop = 0;
              //document.getElementById("selectContact").scrollIntoView();
          }
          this.injectScript()
      }
  }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/contactform/getintouch.vue